import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import API from '@sesame/web-api';
import { Spinner } from 'src/components/Spinner';
import { ILoadState, IRack, IRackComponent, IComponent, IComponentColumn, ISalesorder } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import { beep } from 'src/util/PlaySound';

interface IScanLooseNodeProps {
  rackId: number;
  onElevationChange: () => void;
}
export default function ScanLooseNodeProps({ rackId, onElevationChange }: IScanLooseNodeProps) {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [displayState, setDisplayState] = useState(ILoadState.NEW);
  const [nodeList, setNodeList] = useState<IComponent[]>([]);

  const getLooseNodes = (newRack: number) => {
    setDisplayState(ILoadState.LOADING);
    getAccessTokenSilently().then(accessToken => {

      API.get(accessToken, `/api/v1/rack/${newRack}/components`)
        .then(resp => {
          setNodeList((resp.data as IComponent[]).filter(n => n.parentId == null));
          setDisplayState(ILoadState.READY);
        })
        .catch(err => {
          setDisplayState(ILoadState.ERROR);
        });
    });
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const queryRackId = parseInt(queryParams.get('rack') || '0');
    getLooseNodes(queryRackId);
  }, [getAccessTokenSilently]);

  if (isLoading || displayState == ILoadState.NEW || displayState == ILoadState.LOADING) {
    return <div className="uk-container">
      <Spinner />
    </div>
  }

  if (displayState == ILoadState.ERROR) {
    return <div className="uk-container">
      <h1>Error loading nodes</h1>
    </div>
  }

  return <div className="uk-container">
    <h1>Scan Nodes</h1>
    <form>
      <table data-uk-table>
        <tbody>
          {nodeList.map(n => <NodeSerial node={n} />)}
        </tbody>
      </table>
    </form>
  </div>
}


interface NodeSerialProps {
  node: IComponent;
}
const NodeSerial = ({ node }: NodeSerialProps) => {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [serial, setSerial] = useState(node.serialNumber);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSerial(event.currentTarget.value);
  }

  const onBlur = () => {
    if (!serial) {
      return;
    }
    getAccessTokenSilently().then(accessToken => {
      API.post(accessToken, `/api/v1/component/${node.componentId}/serial`, { serialNumber: serial })
        .then(resp => beep(40, 360))
        .catch(err => {
          Alert(AlertTypes.ERROR, err.message);
        });
    });
  }

  if (isLoading) {
    return <Spinner />
  }
  return <tr key={node.componentId}>
    <td>{node.partNumber}:{node.revision}</td>
    <td>
      <input type="text"
        value={serial}
        onChange={(e) => onChange(e)}
        onBlur={(e) => onBlur()} />
    </td>
  </tr>
}
